export const PROJECTS = 'projects'

export const projects = {
  en: {
    translation: {
      projects: {
        projectTable: {
          generalLabour: 'General Labor',
          projectManager: 'FPM',
          woDraw: 'WO Draw',
          status: 'Status',
          address: 'Address',
          city: 'City',
          clientStart: 'Client Start',
          clientDue: 'Client Due',
          type: 'Type',
          projectCoordinator: 'PC',
          accountPayable: 'AP',
          zip: 'Zip',
          client: 'Client',
          sow: 'SOW',
          projectCost: 'Project Cost',
          paid: 'Paid',
          invoiceNumber: 'Invoice No',
          accountRecievable: 'AR',
          market: 'Market',
          state: 'State',
          woaFinish: 'WOA Finish',
          region: 'Region',
          partialPayment: 'Partial Payment',
          expectedPayment: 'Expected Payment',
          percentagePaid: '% Paid',
          profitMargins: 'Profit Margins',
          profitPercentage: 'Profit %',
          profitTotal: 'Profit Total',
          materialCost: 'Material Cost',
          draw: 'WO Draw',
          sowDraw: 'SOW Draw',
          woNo: 'WO No',
          poNo: 'PO No',
          invoiceDate: 'Invoice Date',
          disqualifiedRevenueFlag: 'Disqualified Revenue',
        },
        projectFilter: {
          new: 'New',
          active: 'Active',
          punch: 'Punch',
          reconcile: 'Reconcile',
          closed: 'Closed',
          invoiced: 'Invoiced',
          clientPaid: 'Client Paid',
          pastDue: 'Past Due',
          overpayment: 'Overpayment',
          disputed: 'Disputed',
          collection: 'Collection',
        },
        projectSummary: {
          projectID: 'Project ID',
          status: 'Status',
          client: 'Client',
          projectDue: 'Project Due',
          fpmName: 'FPM Name',
          fpmContact: 'FPM Contact',
          seeMore: 'See More',
          seeLess: 'See Less',
          address: 'Address',
          projectName: 'Project Name',
          lockBoxCode: 'Lock Box Code',
          projectType: 'Location',
          clientStart: 'Client Start Date',
          clientEnd: 'Client End Date',
          woaStart: 'WOA Start Date',
          woaEnd: 'WOA End',
          pcName: 'PC Name',
          pcContact: 'PC Contact',
        },
        projectAmount: {
          finalSOW: 'Final SOW',
          accountPayable: 'Account Payable',
          projectCost: 'Project Cost',
          revenue: 'Revenue',
          profits: 'Profits',
          profitMargins: 'Profit Margins',
          vendorPayment: 'Vendor Payment',
          materials: 'Materials',
        },
        ganttChart: {
          name: 'Name',
          trade: 'Trade',
          startDate: 'Start Date',
          endDate: 'End Date',
        },
        projectDetails: {
          transactions: 'Transactions',
          viewDetails: 'View Details',
          newTransaction: 'New Transaction',
          projectDetails: 'Project Details',
          vendorWorkOrders: 'Vendor Work Orders',
          documents: 'Documents',
          notes: 'Notes',
          upload: 'Upload',
          schedule: 'Schedule',
          auditLogs: 'Audit Logs',
        },
        dueProjects: 'Due Projects',
        export: 'Export',
        newProjects: 'New Projects',
      },
    },
  },
  es: {
    translation: {
      projects: {
        projectTable: {
          generalLabour: 'Travail Général',
          projectManager: 'FPM',
          woDraw: 'Sorteo WO',
          status: 'Estado',
          address: 'Dirección',
          city: 'Ciudad',
          clientStart: 'Inicio del Cliente',
          clientDue: 'Vencimiento del Cliente',
          type: 'Tipo',
          projectCoordinator: 'PC',
          accountPayable: 'AP',
          zip: 'Código postal',
          client: 'Cliente',
          sow: 'SOW',
          projectCost: 'Costo del Proyecto',
          paid: 'Pagado',
          invoiceNumber: 'Factura No',
          invoice: 'Factura',
          accountReceivable: 'AR',
          market: 'Mercado',
          state: 'Estado',
          woaFinish: 'Acabado WOA',
          region: 'Región',
          partialPayment: 'Pago Parcial',
          expectedPayment: 'Pago Esperado',
          percentagePaid: '% Payé',
          profitMargins: 'Margen de Ganancia',
          profitPercentage: '% de Ganancia',
          profitTotal: 'Ganancia Total',
          materialCost: 'Costo de Material',
          draw: 'WO Dibujo',
          sowDrow: 'SOW Sorteo',
          woNo: 'WO No',
          poNo: 'PO No',
          invoiceDate: 'Fecha de la factura',
        },
        projectFilter: {
          new: 'Nuevo',
          active: 'Activo',
          punch: 'Puñetazo',
          reconcile: 'Conciliar',
          closed: 'Cerrado',
          invoiced: 'Facturado',
          clientPaid: 'Cliente pagado',
          pastDue: 'Vencido',
          overpayment: 'Sobrepago',
          disputed: 'Cuestionado',
          collection: 'Recopilación',
        },
        projectSummary: {
          projectID: 'Projecto ID',
          status: 'Estado',
          client: 'Cliente',
          projectDue: 'Proyecto debido',
          address: 'Habla a',
          projectName: 'Nombre del proyecto',
          lockBoxCode: 'Código de caja de seguridad',
          projectType: 'Tipo de proyecto',
          clientEnd: 'Fecha de finalización del cliente',
          woaStart: 'Fecha de inicio del WOA',
          woaEnd: 'Fecha de finalización de WOA',
          fpmName: 'FPM nombre',
          fpmContact: 'FPM contacto',
          seeMore: 'Ver más',
          seeLess: 'Ver menos',
          pcName: 'Nombre de la computadora',
          pcContact: 'Contacto de PC',
        },
        projectAmount: {
          finalSOW: 'SOW Finale',
          accountPayable: 'Cuenta por pagar',
          projectCost: 'Costo del proyecto',
          revenue: 'Ingresos',
          profits: 'Ganancias',
          profitMargins: 'Márgenes de beneficio',
          vendorPayment: 'Pago del proveedor',
          materials: 'Materiales',
        },
        ganttChart: {
          name: 'Nombre',
          trade: 'Comercio',
          startDate: 'Fecha de inicio',
          endDate: 'Fecha final',
        },
        projectDetails: {
          transactions: 'Transaccións',
          viewDetails: 'Ver detalles',
          newTransaction: 'Nueva Transacción',
          projectDetails: 'Detalles de ganancias',
          schedule: 'Calendario',
          vendorWorkOrders: 'Órdenes de Trabajo del Proveedor',
          documents: 'Documentos',
          notes: 'Notas',
          upload: 'Subir',
          auditLogs: 'Registros de auditoría',
        },
        dueProjects: 'Proyectos Vencidos',
        export: 'Exportar',
        newProjects: 'Proyectos nuevos',
      },
    },
  },
}
